import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[controlValueToUpperCase]',
  standalone: false,
})
export class ControlValueToUpperCaseDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input') onInputEvent(): void {
    const valueToTransform = this.el.nativeElement.value;

    this.control.control.setValue(valueToTransform.toUpperCase(), {
      emitEvent: false,
    });
  }
}
